var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSalesforce(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.9867 6.68242C9.37635 6.27492 9.91891 6.02236 10.5189 6.02236C11.3167 6.02236 12.0124 6.46859 12.3831 7.13111C12.7144 6.9826 13.0735 6.90604 13.4367 6.90648C14.8753 6.90648 16.0416 8.08693 16.0416 9.54299C16.0416 10.9993 14.8753 12.1798 13.4368 12.1798C13.2645 12.18 13.0925 12.1628 12.9236 12.1285C12.5972 12.7127 11.9753 13.1073 11.2615 13.1073C10.9627 13.1073 10.6801 13.0381 10.4284 12.9149C10.0976 13.6958 9.32681 14.2432 8.42844 14.2432C7.49291 14.2432 6.69562 13.6492 6.38949 12.8162C6.25587 12.8448 6.11735 12.8596 5.97508 12.8596C4.86129 12.8596 3.95831 11.9442 3.95831 10.8149C3.95831 10.0581 4.36409 9.39727 4.96684 9.04377C4.83908 8.74855 4.77335 8.43021 4.77375 8.10853C4.77375 6.80971 5.82446 5.75684 7.12069 5.75684C7.88155 5.75684 8.55789 6.11984 8.9867 6.68242Z",
    fill: "#00A1E0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalesforce);
export default __webpack_public_path__ + "static/media/salesforce.7079d16d033f93dadc14fb51b040a6ce.svg";
export { ForwardRef as ReactComponent };